// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".successModal[data-v-6a460324]{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.popup-wrapper[data-v-6a460324]{position:fixed;margin:0 auto;top:50%!important;transform:translateY(-50%);z-index:1000;overflow-y:auto;display:flex;justify-content:center;align-items:center;max-height:100%;background:rgba(0,0,0,.5)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
